export default {
  permissions: {},
}
